import { RegistrationsDetailsFormStateCustomer as RegistrationDetailsFormStateCustomer } from './RegistrationDetailsFormStateCustomer';
import { RegistrationsDetailsFormStateCloudAccount as RegistrationDetailsFormStateCloudAccount } from './RegistrationDetailsFormStateCloudAccount';
import { RegistrationsDetailsFormStateNewCloudAccount as RegistrationDetailsFormStateNewCloudAccount } from './RegistrationDetailsFormStateNewCloudAccount';

export class RegistrationDetailsFormState {
    customer: RegistrationDetailsFormStateCustomer = new RegistrationDetailsFormStateCustomer();
    cloudAccount: RegistrationDetailsFormStateCloudAccount = new RegistrationDetailsFormStateCloudAccount();
    newCloudAccount: RegistrationDetailsFormStateNewCloudAccount = new RegistrationDetailsFormStateNewCloudAccount();
}
